import { useTranslation } from 'react-i18next'
import KnobChartContainer from '../../chart-molecules/people-based-knob-chart/KnobChartContainer'
import StackedChart from '../../chart-molecules/StackedChart/StackedChart'

const PeopleBasedChartContainer = (props: {
  detailTitle: string
  response: any
  icon: any
  colors: string[]
  userInfo: string
  tooltipLabel: string
  detailFooter: string
  tabIndex: number
  firmList: any
  checkedValue: any
  setCheckedValue: any
}) => {
  const { t } = useTranslation()
  return (
    <div className="row">
      {(props.firmList.length > 1 || props.userInfo === 'SuperAdmin') && (
        <div className="col-3 d-flex justify-content-between flex-column">
          <KnobChartContainer
            icon={props.icon}
            response={props.response}
            total={props.response?.doughnutItems.total}
            detailTitle={props.detailTitle}
            colors={props.colors}
          />

          <div className="mt-3">
            <p style={{ fontSize: '14px' }}>{props.detailFooter}</p>
          </div>
        </div>
      )}

      <div className={props.firmList.length > 1 || props.userInfo === 'SuperAdmin' ? 'col-9' : 'col-12'}>
        <StackedChart
          chartId="peopleBasedChart"
          colors={props.colors}
          tooltipLabel={props.tooltipLabel}
          userInfo={props.userInfo}
          response={props.response}
          checkedValue={props.checkedValue}
          setCheckedValue={props.setCheckedValue}
          tabIndex={props.tabIndex}
          labels={[
            t('dashboard.firm-office-user'),
            t('dashboard.shared-office-user'),
            t('dashboard.remote-office-user'),
          ]}
        />
      </div>
    </div>
  )
}

export default PeopleBasedChartContainer
